import { createApp } from 'vue'
import mitt from 'mitt'
import FAQView from '@vueapp/views/FAQ.vue'



export class FAQ {
    constructor( elements ) {
        if ( elements ) {
            elements.forEach(function (item, key) {
                const emitter = mitt()
                const app = createApp(FAQView, {
                    postId: item.getAttribute('data-post-id'),
                    postSlug: item.getAttribute('data-post-slug')
                })
                app.config.globalProperties.emitter = emitter
                app.mount('#' + item.getAttribute('id') )
            });
        }
    }
}
